import { render, staticRenderFns } from "./ProjectSoilZoneFormGroup.vue?vue&type=template&id=673d9d95"
import script from "./ProjectSoilZoneFormGroup.vue?vue&type=script&lang=js"
export * from "./ProjectSoilZoneFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports